import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import SessionAssessment from "@/components/SessionAssessment";
import { triggerConfetti } from "@/utils/confetti";
import { playCompletionSound } from "@/utils/sounds";
import { trackAssessmentCompleted } from "@/utils/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AssessmentPage({ user, onLogout }) {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [module, setModule] = useState(null);

  const loadModule = async () => {
    try {
      const modulesRes = await axios.get(`${API}/modules`);
      const foundModule = modulesRes.data.find(m => m.id === moduleId);
      
      if (foundModule) {
        setModule(foundModule);
      } else {
        // Module not found, redirect to dashboard
        navigate("/dashboard");
      }
      
      setLoading(false);
    } catch (err) {
      console.error("Error loading module:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadModule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  const handleAssessmentComplete = () => {
    triggerConfetti();
    playCompletionSound();
    trackAssessmentCompleted({ role: user?.role, moduleName: module?.title, assessmentType: "session_assessment" });
    
    // Return to module view or dashboard
    setTimeout(() => {
      navigate(`/lessons/${moduleId}`);
    }, 2000);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-50 flex items-center justify-center">
        <div className="text-2xl text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!module) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-50">
      <Navbar user={user} onLogout={onLogout} />

      <div className="container mx-auto px-4 py-8">
        <SessionAssessment
          moduleId={moduleId}
          sessionNumber={module.order}
          onComplete={handleAssessmentComplete}
        />
      </div>
    </div>
  );
}

export default AssessmentPage;
